import { useQueries } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import { StockMarketEnum } from "../features/api/openData";
import { useOspApiClientProvider } from "./useOspApiClientProvider";

export const useStockMarketSchedule = () => {
  const { openDataApi } = useOspApiClientProvider();

  const {
    data,
    isLoading,
    isFetching,
    isPending,
    isSuccess,
    isError,
    isRefetching,
    isStale,
    refetch,
  } = useQueries({
    queries: [
      {
        queryKey: [QUERY_KEYS.STOCK_MARKET_SCHEDULE, StockMarketEnum.US],
        staleTime: 60 * 60 * 1000, // 1小时
        queryFn: async () => {
          const { data } = await openDataApi!.stocks.getMarketSchedule({
            market: StockMarketEnum.US,
          });
          return data?.data;
        },
      },
      {
        queryKey: [QUERY_KEYS.STOCK_MARKET_SCHEDULE, StockMarketEnum.HK],
        staleTime: 60 * 60 * 1000, // 1小时
        queryFn: async () => {
          const { data } = await openDataApi!.stocks.getMarketSchedule({
            market: StockMarketEnum.HK,
          });
          return data?.data;
        },
      },
    ],
    combine: (results) => {
      const [usData, hkData] = results;
      return {
        data: {
          us: usData?.data,
          hk: hkData?.data,
        },
        isPending: results.some((result) => result.isPending),
        isError: results.some((result) => result.isError),
        isSuccess: results.every((result) => result.isSuccess),
        isFetching: results.some((result) => result.isFetching),
        isLoading: results.some((result) => result.isLoading),
        isRefetching: results.some((result) => result.isRefetching),
        isStale: results.some((result) => result.isStale),
        refetch: () => {
          results.forEach((result) => result.refetch());
        },
      };
    },
  });
  return {
    data,
    isLoading,
    isFetching,
    isPending,
    isSuccess,
    isError,
    isRefetching,
    isStale,
    refetch,
  };
};
